<template>
	<page>
		<h1>{{ $t('nav.dashboard') }}</h1>

		<content-loader :message="$t('loading')" v-if="loading" />
		<template v-else-if="clients.length > 0">
			<b-row class="mb-1">
				<b-col cols="12" xl="6">
					<online-devices
						header="Devices By Status"
						:online-count="onlineDeviceCount"
						:offline-count="offlineDeviceCount"
						:syncing-count="syncingDeviceCount"
						:unknown-count="unknownStatusDeviceCount"
						height="300"
					/>
				</b-col>
				<b-col cols="12" xl="6">
					<device-status-by-client
						v-if="onlineDeviceCount > 0 && clients.length > 1"
						header="Online Devices by Client"
						client-field="online_parent_device_count"
						:clients="clients"
						height="300"
					/>
				</b-col>
				<b-col cols="12" xl="6">
					<device-status-by-client
						v-if="offlineDeviceCount > 0 && clients.length > 1"
						header="Offline Devices by Client"
						client-field="offline_parent_device_count"
						:clients="clients"
						height="300"
					/>
				</b-col>
			</b-row>
		</template>
		<template v-else>
			<b-jumbotron
				header="Cannot Display Metrics"
				lead="You currently do not have access to view metrics for Universal Dashboard. If you think this is an error, please contact a system administrator" />
		</template>
	</page>
</template>

<script>
import Page from '../components/layout/Page';
import ErrorModal from '../mixins/ErrorModal';
import ContentLoader from '../components/ContentLoader';
import OnlineDevices from '../components/widgets/OnlineDevices';
import nprogress from 'nprogress';
import DeviceStatusByClient from '../components/widgets/DeviceStatusByClient';

export default {
	components: {
		OnlineDevices,
		DeviceStatusByClient,
		Page,
		ContentLoader
	},

	mixins: [ ErrorModal ],

	mounted () {
		this.refresh();
	},

	data () {
		return {
			loading: true,
			clients: []
		};
	},

	methods: {
		refresh () {
			this.loading = true;

			this.$store.dispatch('metrics/fetchDashboard')
				.then(data => {
					this.clients = data;
				})
				.catch(error => {
					this.showErrorModal(error, 'Error Retrieving Dashboard Data');
				})
				.finally(() => {
					this.loading = false;
					nprogress.done();
				});
		}
	},

	computed: {
		onlineDeviceCount () {
			let count = 0;

			for (const client of this.clients) {
				count += client.online_parent_device_count;
			}

			return count;
		},
		offlineDeviceCount () {
			let count = 0;

			for (const client of this.clients) {
				count += client.offline_parent_device_count;
			}

			return count;
		},
		syncingDeviceCount () {
			let count = 0;

			for (const client of this.clients) {
				count += client.syncing_parent_device_count;
			}

			return count;
		},
		unknownStatusDeviceCount () {
			let count = 0;

			for (const client of this.clients) {
				count += client.unknown_status_parent_device_count;
			}

			return count;
		}
	}
};
</script>
